import { z } from "zod";
import { BehaviorDescriptor, PlaceableDescriptor } from "./descriptor";

// D70 — `loumy.manifest.json` (JSON, generiert vom Extraktor ODER committet bei FS-Access).
//
// SSOT-Regel: das Manifest enthält AUSSCHLIESSLICH `source:"project"`-Descriptoren + den Asset-
// Katalog + die Binding-Map. Die Built-ins (`source:"builtin"`) liefert das Editor-Typ-Paket EAGER
// (Code) — NICHT das Manifest. Der ManifestLoader (Phase 2) merged beide zu EINER Descriptor-
// Registry und prüft fail-closed auf Duplicate-IDs sowie auf Versions-Kompatibilität.
//
// Das Manifest NIE von Hand pflegen (sonst Drift vom Code) — TOML-Fallback (`*.behavior.toml`) ist
// der einzige hand-gepflegte Weg, und auch der wird vom CLI-Generierungs-Kern (D73) ins Manifest
// aggregiert.

/** Aktuelle Manifest-Schema-Version (der Loader lehnt abweichende fail-closed ab). v2 = `placeables` statt `assets` (D82). */
export const MANIFEST_SCHEMA_VERSION = 2 as const;

export const Manifest = z.object({
  /** Inkompatibilitäts-Riegel (D70, PRD §1.2/§1.3): der Loader prüft fail-closed. */
  schemaVersion: z.number().int().positive(),
  /** Welcher Editor-Typ dieses Projekt bedient (z.B. "platformer-2d"). */
  editorType: z.string().min(1),
  /** Ziel-Engine (z.B. "phaser"). */
  engine: z.string().min(1),
  /** Engine-Version für Kompatibilitäts-Prüfung (z.B. "4.x"). */
  engineVersion: z.string().min(1),
  /** Version des erzeugenden Extraktors (Wartungsrealität D73). */
  extractorVersion: z.string().min(1),
  /** NUR `source:"project"`-Descriptoren (Loader erzwingt das fail-closed). */
  behaviors: z.array(BehaviorDescriptor).default([]),
  /** Placeable-Katalog (Sprites + grafiklose Region/Punkt-Placeables, D82). */
  placeables: z.array(PlaceableDescriptor).default([]),
  /** id → natives Symbol ("Modulpfad#Export"); vom Extraktor gesetzt, entlastet eine Hand-Registry. */
  bindings: z.record(z.string(), z.string()).default({}),
});
export type Manifest = z.infer<typeof Manifest>;
